class AuthKeyStore{ 
    constructor(){
        this.passwordList = [
            "6fehRyD5bDdae3yUYyguJhjxREQRVYWz",
            "jyWGc3Zu3ssLghfWVNrQxeFeLVYMCM7f",
            "4jdzWDje2MAG5caQXPq6hS3SY2FBCZjq",
            "5WL4a4PzAj5T8N4URtz3tmP7qNXRbT3J",
            "wwmve7CKPKqKhnenpTwmUTpnBk2785Tq",
            "UpMbfKHReQc5fvPPDBktjH8Yww7xqQXK",
            "ajqX9HM27zQPe5c2RXESfhtSb3qHRMZc",
            "XgQ8Mxr68DBxYyeZ4JsK9eTYJRHKaqsk",
            "UYdHw4brrJ8RMVJPG96n8Xcnw7CWSbAB",
            "KcfxvjtCAZNdC5dqbE5aQkgdXZnGz9Fr",
            "EEts9cnZHhe5THfrVELqPQe3C6Q2QuVK",
            "jpquEFGeEeb4KEQq9fqRKqCg7qwNGKRv",
            "B8XLhZ9fgXLjeadU2NqeG5LMuraQkARm",
            "M9QWfcBn4Cf7Jqyq3xQ9JbQtMhPBnnsu",
            "wTmunu6Sb3GTX9nmyZCZ5MqDBSq2962X",
            "W9LEGJ4mBXA5WdDXwNpG7eyd7EwAn9Q3",
            "T4Z75dYpkA7pXyhnEYdNzs9EZx5V3fym",
            "rEAJqkatfzRcYCBrZS4Su7HPfyG7vb5D",
            "mvS7ez957Zxg5JNFutRXxLBfrhzLqMmX",
            "7FYNf8XZ6EMNBkftmDP5tRxhVamSJUtG"
        ]
    }

    // Proly best to move this to a more secured file
    retrievePassword(){
        return this.passwordList[Math.floor(Math.random() * this.passwordList.length)];
    }
}

module.exports = AuthKeyStore;